import { render, staticRenderFns } from "./SurgicalCaseForm.vue?vue&type=template&id=46e4b111&scoped=true&"
import script from "./SurgicalCaseForm.vue?vue&type=script&lang=js&"
export * from "./SurgicalCaseForm.vue?vue&type=script&lang=js&"
import style0 from "./SurgicalCaseForm.vue?vue&type=style&index=0&id=46e4b111&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e4b111",
  null
  
)

export default component.exports